import { OrderFields } from "../../../constants";
import { TOrderFormData } from "../../../models/orderForm";
import type { TNewAddressForm } from "../types";

// Used to take only those fields from order which are relevant to new address creation

const mapOrderDataToNewAddressData = (orderData: TOrderFormData): Partial<TNewAddressForm> => ({
  [OrderFields.NEW_ADDRESS_NAME]: orderData[OrderFields.NEW_ADDRESS_NAME]!,
  [OrderFields.NEW_ADDRESS_PHONE]: orderData[OrderFields.NEW_ADDRESS_PHONE]!,
  [OrderFields.NEW_ADDRESS_EMAIL]: orderData[OrderFields.NEW_ADDRESS_EMAIL] || undefined,
  [OrderFields.DESTINATION_COUNTRY]: orderData[OrderFields.DESTINATION_COUNTRY]!,
  [OrderFields.NEW_ADDRESS_LOCKER]: orderData[OrderFields.NEW_ADDRESS_LOCKER] || undefined,
  [OrderFields.NEW_ADDRESS_LOCKER_NAME]: orderData[OrderFields.NEW_ADDRESS_LOCKER_NAME] || undefined,
  [OrderFields.NEW_ADDRESS_STREET]: orderData[OrderFields.NEW_ADDRESS_STREET] || undefined,
  [OrderFields.NEW_ADDRESS_HOUSE_NO]: orderData[OrderFields.NEW_ADDRESS_HOUSE_NO] || undefined,
  [OrderFields.NEW_ADDRESS_FLAT_NO]: orderData[OrderFields.NEW_ADDRESS_FLAT_NO] || undefined,
  [OrderFields.NEW_ADDRESS_CITY]: orderData[OrderFields.NEW_ADDRESS_CITY] || undefined,
  [OrderFields.NEW_ADDRESS_ZIP_CODE]: orderData[OrderFields.NEW_ADDRESS_ZIP_CODE] || undefined,
});
export default mapOrderDataToNewAddressData;
